import _slicedToArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from 'react';
var Source = function Source(props) {
  var src = props.src,
    src2dpr = props.src2dpr,
    mimeType = props.mimeType;
  var srcSet = src && src2dpr ? "".concat(src, " 1x, ").concat(src2dpr, " 2x") : src;
  return React.createElement("source", {
    srcSet: srcSet,
    type: mimeType
  });
};
export var Picture = function Picture(props) {
  var alt = props.alt,
    className = props.className;
  var _props$src = _slicedToArray(props.src, 2),
    src = _props$src[0],
    src2dpr = _props$src[1];
  var _ref = props.webp || [],
    _ref2 = _slicedToArray(_ref, 2),
    webp = _ref2[0],
    webp2dpr = _ref2[1];
  var fallbackImage = src2dpr || src;
  return React.createElement("picture", null, props.webp && React.createElement(Source, {
    mimeType: "image/webp",
    src: webp,
    src2dpr: webp2dpr
  }), React.createElement(Source, {
    src: src,
    src2dpr: src2dpr
  }), React.createElement("img", {
    src: fallbackImage,
    alt: alt,
    className: className
  }));
};